import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';

import {HomePage} from "../../pages/home/home";
import {OrderPage} from "../../pages/order/order";
import {PvsPage} from "../../pages/pvs/pvs";
import {WareneingangPage} from "../../pages/wareneingang/wareneingang";
import {OrdersPage} from "../../pages/orders/orders";

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider {

  public user;
  public role;
  public orders;

  public loading = true;

  public search_text = '';
  public search_results = [];

  public messages = [];
  public unread_count = 0;

  public last_touchstart = null;

  public roleChange = new EventEmitter<any>();

  interval = {
    current: 'fast',
    slow: 60000,
    fast: 5000
  };

  inter;


  constructor(public http: HttpClient) {
    console.log("instance dataProvicer create");
    localStorage.getItem('last_message_timestamp');
  }

  loadList() {
    const body = {
      token: localStorage.getItem('token'),
      module: 'orders',
      submodule: 'device_list',
      app_version: '2',
      message_timestamp: localStorage.getItem('last_message_timestamp')
    };
    const sub = this.http.post(environment.api_url, body).subscribe(daten => {
        this.orders = daten['data']['orders'];
        this.unread_count = daten['data']['msgs'];
        if (this.role !== daten['data']['role']) {
          this.role = daten['data']['role'];
          this.roleChange.emit(this.role);
        }
        sub.unsubscribe();
      }, error => {
      }
    );
  }

  loadMessageList() {
    const body = {
      token: localStorage.getItem('token'),
      module: 'messages',
      submodule: 'list',
    };
    const sub = this.http.post(environment.api_url, body).subscribe(daten => {
      this.messages = daten['data'];
      if (this.messages[0] !== undefined) {
        localStorage.setItem('last_message_timestamp', this.messages[0].timestamp);
      }
      sub.unsubscribe();
      }, error => {
      }
    );
  }

  changeIntervalList() {
    clearInterval(this.inter);
    this.setIntervalList();
  }

  setIntervalList() {
    this.inter = setInterval(() => {
      this.loadList();
      this.checkInterval();
    }, this.interval[this.interval.current]);
  }

  checkInterval() {
    if (Math.round(new Date().getTime()/1000) > this.last_touchstart + 30) {
      if (this.interval.current !== 'slow') {
        this.interval.current = 'slow';
        this.changeIntervalList();
      }
    } else {
      if (this.interval.current !== 'fast') {
        this.interval.current = 'fast';
        this.changeIntervalList();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts